import getApi from '../../../api'
import { singleItemPageLimit } from '../../../constants'
import { Filters } from '../../../model/Filters'
import { OrganizationInterop } from '../../../model/OrganizationInterop'
import { PaginatedList } from '../../../model/Pagination'

export const getOrganizationsInterop = (
  page: number,
  filters?: Filters,
  signal?: AbortSignal,
  limit = singleItemPageLimit,
) =>
  getApi().get<PaginatedList<OrganizationInterop>>(
    '/admin/interop/organizations',
    { page, limit, ...filters },
    { signal },
  )
